import React from "react";
import { Container } from "react-bootstrap";
import { AiOutlineEye } from "react-icons/ai";
import {Link} from 'react-router-dom'
import { BsBagCheck,BsSuitHeart} from "react-icons/bs";
import './BestSale.css'
const BestSale = () => {
  return (
    <div className="section-container most-view-container">
      <Container>
        <div className="section-heading text-center">
          <span>Popular Items</span>
          <h2>Best Sale of This Week</h2>
          <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Accusantium quos cupiditate vero <br /> veniam repellat illum quo labore ullam magni provident?</p>
        </div>
        <div className="row">
        <div className="col-6 col-md-6 col-lg-4 col-xl-3 py-2">
            <div className="most-view-card">
              <div className="most-view-card-img">
                <img
                  src={require("../../../images/features/feature4.png")}
                  alt=""
                  className="w-100 h-100"
                />
                <div className="details-button-group">
                  <Link to="products/5">
                    <button className="w-100 p-2 border-0 bg-transparent text-light">
                      Buy Now
                    </button>
                  </Link>
                </div>
                <div className="details-button-group2 pt-3">
                  <button className="border-0 profile-icon my-1 text-dark d-flex align-items-center justify-content-center">
                    <BsSuitHeart />
                  </button>
                  <button className="border-0 profile-icon my-1 text-dark d-flex align-items-center justify-content-center">
                    <AiOutlineEye />
                  </button>
                  <button className="border-0 profile-icon my-1 text-dark d-flex align-items-center justify-content-center">
                    <BsBagCheck />
                  </button>
                </div>
              </div>
              <div className="most-view-card-text d-flex align-items-center justify-content-between text-center p-2">
                <h5 className="fw-light m-0">Mens Shirt</h5>
                <h5 className="fw-normal text-dark m-0">$12.99</h5>
              </div>
            </div>
          </div>
          <div className="col-6 col-md-6 col-lg-4 col-xl-3 py-2">
            <div className="most-view-card">
              <div className="most-view-card-img">
                <img
                  src={require("../../../images/features/feature2.png")}
                  alt=""
                  className="w-100 h-100"
                />
                <div className="details-button-group">
                  <Link to="products/5">
                    <button className="w-100 p-2 border-0 bg-transparent text-light">
                      Buy Now
                    </button>
                  </Link>
                </div>
                <div className="details-button-group2 pt-3">
                  <button className="border-0 profile-icon my-1 text-dark d-flex align-items-center justify-content-center">
                    <BsSuitHeart />
                  </button>
                  <button className="border-0 profile-icon my-1 text-dark d-flex align-items-center justify-content-center">
                    <AiOutlineEye />
                  </button>
                  <button className="border-0 profile-icon my-1 text-dark d-flex align-items-center justify-content-center">
                    <BsBagCheck />
                  </button>
                </div>
              </div>
              <div className="most-view-card-text d-flex align-items-center justify-content-between text-center p-2">
                <h5 className="fw-light m-0">Mens Shirt</h5>
                <h5 className="fw-normal text-dark m-0">$12.99</h5>
              </div>
            </div>
          </div>
          <div className="col-6 col-md-6 col-lg-4 col-xl-3 py-2">
            <div className="most-view-card">
              <div className="most-view-card-img">
                <img
                  src={require("../../../images/features/feature5.png")}
                  alt=""
                  className="w-100 h-100"
                />
                <div className="details-button-group">
                  <Link to="products/5">
                    <button className="w-100 p-2 border-0 bg-transparent text-light">
                      Buy Now
                    </button>
                  </Link>
                </div>
                <div className="details-button-group2 pt-3">
                  <button className="border-0 profile-icon my-1 text-dark d-flex align-items-center justify-content-center">
                    <BsSuitHeart />
                  </button>
                  <button className="border-0 profile-icon my-1 text-dark d-flex align-items-center justify-content-center">
                    <AiOutlineEye />
                  </button>
                  <button className="border-0 profile-icon my-1 text-dark d-flex align-items-center justify-content-center">
                    <BsBagCheck />
                  </button>
                </div>
              </div>
              <div className="most-view-card-text d-flex align-items-center justify-content-between text-center p-2">
                <h5 className="fw-light m-0">Mens Shirt</h5>
                <h5 className="fw-normal text-dark m-0">$12.99</h5>
              </div>
            </div>
          </div>
          <div className="col-6 col-md-6 col-lg-4 col-xl-3 py-2">
            <div className="most-view-card">
              <div className="most-view-card-img">
                <img
                  src={require("../../../images/features/feature6.png")}
                  alt=""
                  className="w-100 h-100"
                />
                <div className="details-button-group">
                  <Link to="products/5">
                    <button className="w-100 p-2 border-0 bg-transparent text-light">
                      Buy Now
                    </button>
                  </Link>
                </div>
                <div className="details-button-group2 pt-3">
                  <button className="border-0 profile-icon my-1 text-dark d-flex align-items-center justify-content-center">
                    <BsSuitHeart />
                  </button>
                  <button className="border-0 profile-icon my-1 text-dark d-flex align-items-center justify-content-center">
                    <AiOutlineEye />
                  </button>
                  <button className="border-0 profile-icon my-1 text-dark d-flex align-items-center justify-content-center">
                    <BsBagCheck />
                  </button>
                </div>
              </div>
              <div className="most-view-card-text d-flex align-items-center justify-content-between text-center p-2">
                <h5 className="fw-light m-0">Mens Shirt</h5>
                <h5 className="fw-normal text-dark m-0">$12.99</h5>
              </div>
            </div>
          </div>
          <div className="col-6 col-md-6 col-lg-4 col-xl-3 py-2">
          <div className="most-view-card">
              <div className="most-view-card-img">
                <img
                  src={require("../../../images/most-view/view1.png")}
                  alt=""
                  className="w-100 h-100"
                />
                <div className="details-button-group">
                <Link to="products/5"><button className="w-100 p-2 border-0 bg-transparent text-light">Buy Now</button></Link>
                </div>
                <div className="details-button-group2 pt-3">
                  <button className="border-0 profile-icon my-1 text-dark d-flex align-items-center justify-content-center">
                    <BsSuitHeart />
                  </button>
                  <button className="border-0 profile-icon my-1 text-dark d-flex align-items-center justify-content-center">
                    <AiOutlineEye />
                  </button>
                  <button className="border-0 profile-icon my-1 text-dark d-flex align-items-center justify-content-center">
                    <BsBagCheck />
                  </button>
                </div>
              </div>
              <div className="most-view-card-text d-flex align-items-center justify-content-between text-center p-2">
                <h5 className="fw-light m-0">Mens Shirt</h5>
                <h5 className="fw-normal text-dark m-0">$12.99</h5>
              </div>
            </div>
          </div>
          <div className="col-6 col-md-6 col-lg-4 col-xl-3 py-2">
          <div className="most-view-card">
              <div className="most-view-card-img">
                <img
                  src={require("../../../images/most-view/view2.png")}
                  alt=""
                  className="w-100 h-100"
                />
                <div className="details-button-group">
                <Link to="products/5"><button className="w-100 p-2 border-0 bg-transparent text-light">Buy Now</button></Link>
                </div>
                <div className="details-button-group2 pt-3">
                  <button className="border-0 profile-icon my-1 text-dark d-flex align-items-center justify-content-center">
                    <BsSuitHeart />
                  </button>
                  <button className="border-0 profile-icon my-1 text-dark d-flex align-items-center justify-content-center">
                    <AiOutlineEye />
                  </button>
                  <button className="border-0 profile-icon my-1 text-dark d-flex align-items-center justify-content-center">
                    <BsBagCheck />
                  </button>
                </div>
              </div>
              <div className="most-view-card-text d-flex align-items-center justify-content-between text-center p-2">
                <h5 className="fw-light m-0">Mens Shirt</h5>
                <h5 className="fw-normal text-dark m-0">$12.99</h5>
              </div>
            </div>
          </div>
          <div className="col-6 col-md-6 col-lg-4 col-xl-3 py-2">
          <div className="most-view-card">
              <div className="most-view-card-img">
                <img
                  src={require("../../../images/most-view/view3.png")}
                  alt=""
                  className="w-100 h-100"
                />
                <div className="details-button-group">
                <Link to="products/5"><button className="w-100 p-2 border-0 bg-transparent text-light">Buy Now</button></Link>
                </div>
                <div className="details-button-group2 pt-3">
                  <button className="border-0 profile-icon my-1 text-dark d-flex align-items-center justify-content-center">
                    <BsSuitHeart />
                  </button>
                  <button className="border-0 profile-icon my-1 text-dark d-flex align-items-center justify-content-center">
                    <AiOutlineEye />
                  </button>
                  <button className="border-0 profile-icon my-1 text-dark d-flex align-items-center justify-content-center">
                    <BsBagCheck />
                  </button>
                </div>
              </div>
              <div className="most-view-card-text d-flex align-items-center justify-content-between text-center p-2">
                <h5 className="fw-light m-0">Mens Shirt</h5>
                <h5 className="fw-normal text-dark m-0">$12.99</h5>
              </div>
            </div>
          </div>
          <div className="col-6 col-md-6 col-lg-4 col-xl-3 py-2">
          <div className="most-view-card">
              <div className="most-view-card-img">
                <img
                  src={require("../../../images/most-view/view4.png")}
                  alt=""
                  className="w-100 h-100"
                />
                <div className="details-button-group">
                <Link to="products/5"><button className="w-100 p-2 border-0 bg-transparent text-light">Buy Now</button></Link>
                </div>
                <div className="details-button-group2 pt-3">
                  <button className="border-0 profile-icon my-1 text-dark d-flex align-items-center justify-content-center">
                    <BsSuitHeart />
                  </button>
                  <button className="border-0 profile-icon my-1 text-dark d-flex align-items-center justify-content-center">
                    <AiOutlineEye />
                  </button>
                  <button className="border-0 profile-icon my-1 text-dark d-flex align-items-center justify-content-center">
                    <BsBagCheck />
                  </button>
                </div>
              </div>
              <div className="most-view-card-text d-flex align-items-center justify-content-between text-center p-2">
                <h5 className="fw-light m-0">Mens Shirt</h5>
                <h5 className="fw-normal text-dark m-0">$12.99</h5>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default BestSale;
